import { useAlarmTypesByName } from '@hakimo-ui/hakimo/data-access';
import { AlarmTypeFilterValue, TimeFilterValue } from '@hakimo-ui/hakimo/types';
import { currentTenantAtom } from '@hakimo-ui/hakimo/util';
import { useAtomValue } from 'jotai';
import { MultiSelectFilter } from '../multi-select-filter/MultiSelectFilter';
import { getSearchParams } from '../utils';

interface Props {
  value: AlarmTypeFilterValue;
  label: string;
  enableNegativeFilters?: boolean;
  onChange: (value: AlarmTypeFilterValue) => void;
  timeFilterValue?: TimeFilterValue;
}

function AlarmTypeFilter(props: Props) {
  const {
    value,
    label,
    enableNegativeFilters = false,
    onChange,
    timeFilterValue,
  } = props;
  const getAlarmTypesByName = useAlarmTypesByName(
    getSearchParams(undefined, timeFilterValue)
  );
  const currentTenant = useAtomValue(currentTenantAtom);

  return (
    <MultiSelectFilter
      value={value}
      label={label}
      enableNegativeFilters={enableNegativeFilters}
      onChange={onChange}
      getOptions={(name: string) =>
        getAlarmTypesByName(name, currentTenant?.id || '')
      }
    />
  );
}

export default AlarmTypeFilter;
